<template>
 <svg>
    <template v-if="operator === 'AND'">
      <rect class="and cls-1" x="0.75" y="0.75" width="96.94" height="61.09" rx="2.86" />
      <path class="and cls-2" d="M49.22,10.92V51.67a26,26,0,0,1,0-40.75Z" />
      <path class="and cls-2" d="M59.08,31.29a25.84,25.84,0,0,1-9.86,20.38V10.92A25.81,25.81,0,0,1,59.08,31.29Z" />
      <path class="and cls-3" d="M49.22,10.86a25.83,25.83,0,0,0,0,40.87,25.83,25.83,0,0,0,0-40.87Zm0,40.81a26,26,0,0,1,0-40.75,26,26,0,0,1,0,40.75Z" />
      <path d="M49.53,10.21l-.08-.06L49.22,10l-.23.18-.08.06a26.75,26.75,0,0,0,0,42.17l.08.06.23.18.23-.18.08-.06a26.73,26.73,0,0,0,0-42.17Zm-.31,41.46a26,26,0,0,1,0-40.75,26,26,0,0,1,0,40.75Z" />
      <path class="and cls-1" d="M91.72,31.29a26.36,26.36,0,0,1-42.5,20.85,26.36,26.36,0,0,0,0-41.7,26.37,26.37,0,0,1,42.5,20.85Z" />
      <path class="and cls-1" d="M49.22,52.14a26.36,26.36,0,1,1,0-41.7,26.36,26.36,0,0,0,0,41.7Z" />
      <text class="and cls-4" transform="translate(21.1 51.62)">A</text>
      <text class="and cls-4" transform="translate(67.05 51.62)">B</text>
    </template>
    <template v-else-if="operator === 'OR'">
      <rect class="or cls-1" x="0.75" y="0.75" width="96.94" height="61.09" rx="2.86" />
      <path class="or cls-2" d="M49.22,10.92V51.67a26,26,0,0,1,0-40.75Z" />
      <path class="or cls-2" d="M59.07,31.29a25.83,25.83,0,0,1-9.85,20.38V10.92A25.83,25.83,0,0,1,59.07,31.29Z" />
      <path class="or cls-3" d="M49.22,10.85a25.84,25.84,0,0,0,0,40.88,25.86,25.86,0,0,0,0-40.88Zm0,40.82a26,26,0,0,1,0-40.75,26,26,0,0,1,0,40.75Z" />
      <path class="or cls-3" d="M49.53,10.2l-.08-.06L49.22,10l-.23.18a.27.27,0,0,0-.08.07,26.73,26.73,0,0,0,0,42.17l.08.06.23.18.23-.18.08-.06a26.76,26.76,0,0,0,0-42.18Zm-.31,41.47a26,26,0,0,1,0-40.75,26,26,0,0,1,0,40.75Z" />
      <path class="or cls-4" d="M91.72,31.29a26.37,26.37,0,0,1-42.5,20.86,26.37,26.37,0,0,0,0-41.71,26.36,26.36,0,0,1,42.5,20.85Z" />
      <path class="or cls-4" d="M49.22,52.15a26.38,26.38,0,1,1,0-41.71,26.36,26.36,0,0,0,0,41.71Z" />
      <text class="or cls-5" transform="translate(21.1 51.67)">A</text>
      <text class="or cls-5" transform="translate(67.05 51.67)">B</text>
    </template>
    <template v-else-if="operator === 'NOT'">
      <rect class="not cls-1" x="0.75" y="0.75" width="96.94" height="61.09" rx="2.86" />
      <circle class="not cls-2" cx="49.23" cy="31.29" r="26.64" />
      <text class="not cls-3" transform="translate(43.41 51.73)">A</text>
    </template>
  </svg>
</template>
<script>
export default {
  props: {
    operator: String
  }
}
</script>
<style lang="scss" scoped>
  .and {
    &.cls-1 {
      fill: #fff;
      stroke: #dddbda;
    }

    &.cls-1,
    &.cls-2 {
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2 {
      fill: #4589ee;
      stroke: #4589ee;
    }

    &.cls-3 {
      fill: #a9ddf3;
    }

    &.cls-4 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }
  }

  .not {
    &.cls-1 {
      fill: #4589ee;
    }

    &.cls-1,
    &.cls-2 {
      stroke: #dddbda;
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2 {
      fill: #fff;
    }

    &.cls-3 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }
  }

  .or {
    &.cls-1 {
      fill: #fff;
    }

    &.cls-1,
    &.cls-4 {
      stroke: #dddbda;
    }

    &.cls-1,
    &.cls-2,
    &.cls-4 {
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }

    &.cls-2,
    &.cls-3,
    &.cls-4 {
      fill: #4589ee;
    }

    &.cls-2 {
      stroke: #4589ee;
    }
    &.cls-5 {
      font-size: 19px;
      fill: #c1c1c1;
      font-family: 'Salesforce Sans';
    }
  }
</style>
